export default __webpack_public_path__ + "locales/vi/DeleteDialog.json?hash=9f34d10e83e1800532556d257e43ba5b";